// motion/MotionPreferences.tsx
import React, { createContext, useContext, useMemo, useState } from "react";
import { MotionConfig } from "framer-motion";
import useUiPreferences from "src/store/useUiPreferences";

type MotionPrefs = {
  animationsEnabled: boolean;
  setAnimationsEnabled: (v: boolean) => void;
  disableReason?: string;
  setDisableReason: (v?: string) => void;
};

const Ctx = createContext<MotionPrefs | null>(null);

export function useMotionPrefs() {
  const ctx = useContext(Ctx);
  if (!ctx)
    throw new Error("useMotionPrefs must be used within MotionPrefsProvider");
  return ctx;
}

export function MotionPrefsProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  const miscUiPreferences = useUiPreferences((s) => s.misc);

  const [animationsEnabled, setAnimationsEnabled] = useState(true);
  const [disableReason, setDisableReason] = useState<string | undefined>();

  // Si el usuario prefiere reduced motion, apaga sí o sí
  const effectiveEnabled = useMemo(() => {
    return !!miscUiPreferences.enableComplexAnimations;
  }, [miscUiPreferences.enableComplexAnimations]);

  const value = useMemo(
    () => ({
      animationsEnabled: effectiveEnabled,
      setAnimationsEnabled,
      disableReason,
      setDisableReason,
    }),
    [effectiveEnabled, disableReason],
  );

  return (
    <Ctx.Provider value={value}>
      <MotionConfig reducedMotion={effectiveEnabled ? "never" : "always"}>
        {children}
      </MotionConfig>
    </Ctx.Provider>
  );
}
